import { DatePipe } from '@angular/common';
import { Component, ElementRef, HostListener, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from 'src/app/components/modal/modal.component';
import { Popupmodal } from 'src/app/_helpers/popupmodal';
import { MessagingService } from 'src/app/_services/messaging.services';
import { NavigationService } from 'src/app/_services/navigation';
import CheckErrortype from 'src/app/_helpers/check-errortype';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-whatsapp',
  templateUrl: './whatsapp.component.html',
  styleUrls: ['./whatsapp.component.scss']
})
export class WhatsappComponent implements OnInit {
  PageLoading:boolean=false
  jwtToken:string|null=null
  companyUserId:string|null=null
  safeUrl!: SafeResourceUrl;

  innerWidth:any
  public getScreenWidth: any;
  isMobile:boolean=false
  isMobileMessage:boolean=false
  isSubsribed:boolean=false

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private messagingService: MessagingService,
    private popupmodal : Popupmodal,
    public datepipe: DatePipe,
    private navigation: NavigationService,
    private sanitizer: DomSanitizer,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.PageLoading=true
    let getJwt = localStorage.getItem("JWT_TOKEN");
    let getCompanyData = localStorage.getItem("USERCOMPANY");

    if(getJwt && getCompanyData){ 
      this.jwtToken= getJwt
      this.companyUserId= JSON.parse(getCompanyData).id
      const url = environment.WHATSAPP_URL + '?token=' + this.jwtToken + "&key=BImrehtXrKkeA86GAyznPAaSvL34tIkbeOl6WjxWlDm84SDy2Kw6QiwFH7AdqACcMCHxZAQUFCRrseH6rJtJBjk&id=" + this.companyUserId;
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);      
    }
    
    // Check WhatsApp subscription status
    this.checkWhatsappSubscription();
    
    this.PageLoading=false
  }

  checkWhatsappSubscription(): void {
    this.messagingService.getisWhatsappSubscriptionActive().subscribe(
      (res: any) => {
        if (res?.data?.isWhatsappSubscriptionActive === false) {
          //this.showWhatsappSubscriptionModal();
        }
        if(res?.data?.isWhatsappSubscriptionActive === true){
          this.isSubsribed=true
        }
      },
      (error: any) => {
        console.log("Error checking WhatsApp subscription:", error);
      }
    );
  }

  showWhatsappSubscriptionModal(): void {
    this.popupmodal.show({
      class: {
        modalDialogClass: 'modal-dialog-centered',
        centered: true,
        backdrop: 'static',
        keyboard: false,
        size: 'sm'
      },
      modalinfo: 'info',
      infoTitle: 'WhatsApp Required',
      infoFailed: 'WhatsApp required subscription, click below to subscribe.',
      closeTxt: 'Subscribe',
      redirect: '/subscription-products'
    });
  }
  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.getScreenWidth = window.innerWidth;
    if(this.getScreenWidth<575){
      this.isMobile=true
    } else {
      this.isMobile=false
    }
  }


  onSubmit() {
  }

  back(): void {
    this.navigation.back()
  }

  gotoSubscription(): void {
    this.router.navigate(['/subscription-products'])
  }
}
